<ng-container #sidebar>
  <section class="sticky-container">
    <div *ngIf="workspace" data-cy="user-badge-container" class="user-badge minimized" #avatarElement (click)="onAvatarClick($event)">
      <u-icon data-cy="user-badge-icon" class="main-icon" [model]="workspaceIcon"></u-icon>
    </div>
  </section>

  <ng-scrollbar
    [viewClass]="'sidebar-container'"
    visibility="hover"
    class="scrollbar-container"
    [ngClass]="{ invisible: !nodes.length }"
    #scrollbarRef
    (updated)="updateScrollBar()"
  >
    <tree-root
      class="tree"
      (toggleExpanded)="$event.isExpanded === false && unsubscribe($event.node.data?.id)"
      [nodes]="nodes"
      [options]="treeOptions"
      [style.opacity]="nodes?.length === 1 ? 0 : 1"
    >
      <ng-template #treeNodeFullTemplate let-node let-index="index" let-model="node.data" let-templates="templates">
        <div
          *ngIf="!isLauncher || !isEmbed"
          [class]="node.getClass() + ' type-' + model.type + ' group-' + model.group"
          [class.tree-node]="true"
          [class.tree-node-expanded]="node.isExpanded && node.hasChildren"
          [class.tree-node-collapsed]="node.isCollapsed && node.hasChildren"
          [class.tree-node-leaf]="node.isLeaf"
          [class.tree-node-active]="activeNode?.id === node.id || isParentActive(node)"
          [class.tree-node-focused]="node.isFocused"
          [class.tree-node-separator]="node.isFocused"
          [attr.data-node-id]="model.id"
        >
          <tree-node-wrapper
            [attr.data-cy]="'menu-item-container-' + node.data.title"
            [node]="node"
            [index]="index"
            [templates]="templates"
          >
          </tree-node-wrapper>
        </div>
      </ng-template>

      <ng-template #treeNodeWrapperTemplate let-node let-model="node.data" let-index="index" let-templates="templates">
        <div
          [id]="node.data.title"
          class="node-wrapper"
          (click)="node.mouseAction('click', $event)"
          (dblclick)="node.mouseAction('dblClick', $event)"
          (contextmenu)="node.mouseAction('contextMenu', $event)"
          [class.separator]="model.type === 'separator'"
          [class.node-wrapper-active]="activeNode?.id === node.id || isParentActive(node)"
          [class]="'type-' + model.type"
        >
          <ng-container *ngIf="model.type !== 'separator'">
            <div class="node-content-wrapper">
              <tree-node-content
                class="tree-node-content"
                [node]="node"
                [index]="index"
                [ngClass]="{ apps: node.data.group === 'apps' }"
                [template]="templates.treeNodeTemplate"
              >
              </tree-node-content>
            </div>
          </ng-container>
        </div>
      </ng-template>

      <ng-template #treeNodeTemplate let-node let-model="node.data" let-index="index">
        <ng-container *ngTemplateOutlet="model.type === 'separator' ? separator : standard; context: { model: model }"> </ng-container>

        <ng-template #standard let-model="model" let-title="model.title" let-badge="model.badge" let-icon="model.icon">
          <entity-icon
            *ngIf="icon"
            [class]="'tree-node-icon ' + 'tree-node-icon-' + icon.type"
            [model]="icon"
            [size]="'14px'"
            [mirrorClass]="false"
            [pTooltip]="model.type === 'standard' ? node.data.title : null"
            tooltipPosition="right"
            tooltipStyleClass="u-tooltip"
          ></entity-icon>
        </ng-template>
      </ng-template>
    </tree-root>
  </ng-scrollbar>

  <ng-container *ngIf="!nodes?.length">
    <div class="list-ghost">
      <div class="item-container" *ngFor="let i of 8 | fill; index as index">
        <div class="ghost"></div>
      </div>
    </div>
  </ng-container>

  <div *ngIf="bottomMenuItems?.length && (!isLauncher || isEmbed)" class="bottom-menu" id="bottom-menu" [class.has-scroll]="hasScroll()">
    <control-button
      id="QuickActions"
      class="control-button"
      [pTooltip]="commandQuickActionsText"
      tooltipPosition="bottom"
      tooltipStyleClass="u-tooltip"
      [icon]="'icon-quick_action'"
      (click)="$event.stopPropagation(); onQuickActionsClick()"
    >
    </control-button>
    <control-button
      id="fyi"
      #fyiButton
      class="control-button"
      pTooltip="FYI"
      tooltipPosition="bottom"
      tooltipStyleClass="u-tooltip"
      [icon]="isMac ? 'icon-alarm' : 'icon-windows-ringer'"
      (click)="$event.stopPropagation(); onFyiClick()"
      [unread]="unreadFyi$ | async"
      [active]="isFyiActive$ | async"
    >
    </control-button>
    <ng-container *ngFor="let item of bottomMenuItems">
      <nav-item [item]="item" [minimized]="true" [tabIndex]="-1"></nav-item>
    </ng-container>
    <control-button
      id="help"
      #helpButton
      pTooltip="Help"
      tooltipPosition="bottom"
      tooltipStyleClass="u-tooltip"
      class="control-button"
      [icon]="'icon-question'"
      [unread]="false"
      (click)="$event.stopPropagation(); onHelpClick($event)"
      [active]="isHelpActive$ | async"
    >
    </control-button>
  </div>

  <trial-banner
    *ngIf="onTrialPlan"
    [planDaysLeft]="planDaysLeft"
    [bannerType]="'icon-only'"
    [iconOnly]="true"
    (onClick)="trialBannerClick.emit()"
    tooltipPosition="right"
    pTooltip="Upgrade"
    tooltipStyleClass="u-tooltip"
  ></trial-banner>

  <ng-container *ngIf="!bottomMenuItems?.length && (!isLauncher || isEmbed)">
    <div class="list-ghost bottom">
      <div class="item-container" *ngFor="let i of 3 | fill; index as index">
        <div class="ghost"></div>
      </div>
    </div>
  </ng-container>
</ng-container>
